export default __webpack_public_path__ + "static/media/mini.e33899cf.svg";